<div class="contentModal">
  <h1 mat-dialog-title style="color: #3074AA;"><Strong>{{titulo}}</Strong></h1>
  <div mat-dialog-content #dadosMsgInstitucional class="mat-typography">
    <mat-card class="card">
        <div [innerHTML]="innerHtml"></div>
    </mat-card>
  </div>
  <div mat-dialog-actions class="botoes">

     <button mat-raised-button class="md-icon-button btnOK" (click)="onClose()">  OK
     </button>


  </div>
</div>
